import LandingPageState from "./LandingPageState";
import LandingPageGetters from "./LandingPageGetters";
import LandingPageMutations from "./LandingPageMutations";
import LandingPageActions from "./LandingPageActions";

export default {
    state: LandingPageState,
    getters: LandingPageGetters,
    mutations: LandingPageMutations,
    actions: LandingPageActions,
};
